<template>
  <div class="accordion" :class="{ 'is-open': isOpen }">
    <div class="accordion-header" v-if="hasHeader">
      <a class="accordion-link" href="#" @click.prevent="toggleAccordion"> 
        <p class="accordion-title" v-html="title"></p>
        <i
          class="accordion-header-icon"
          :class="{
            'fas fa-chevron-down': !isOpen,
            'fas fa-chevron-up': isOpen
          }"
        ></i>
      </a>
    </div>
    <div
      class="accordion-body"
      ref="accordion" 
      :style="{ height: accordionHeight }"
    >
      <slot></slot>
    </div>
    <div class="accordion-footer" v-if="hasFooter">
      <a class="accordion-link" href="#" @click.prevent="toggleAccordion"> 
        <i
          class="accordion-footer-icon"
          :class="{
            'fas fa-chevron-down': !isOpen,
            'fas fa-chevron-up': isOpen
          }"
        ></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasHeader: {
      type: Boolean,
      default: false
    },
    hasFooter: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false
    },
    defaultOpen: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isOpen: this.defaultOpen,
      accordionHeight: this.defaultOpen ? 'auto' : 0,
    }
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.slideDown()
      } else {
        this.slideUp()
      }
    },
    slideDown() {
      const targetMaxHeight = this.$refs.accordion.children[0].clientHeight
      let targetHeight = 0
      const heightPerTime = targetMaxHeight / 50
      const slideDown = () => {
        const slideDownTimer = setInterval(() => {
          targetHeight += heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight >= targetMaxHeight) {
            clearInterval(slideDownTimer)
            this.accordionHeight = 'auto'
          }
        }, 5)
      }
      slideDown()
    },
    slideUp() {
      let targetHeight = this.$refs.accordion.children[0].clientHeight
      const heightPerTime = targetHeight / 50
      const slideUp = () => {
        const slideUpTimer = setInterval(() => {
          targetHeight -= heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight <= 0) {
            clearInterval(slideUpTimer)
            this.accordionHeight = 0
          }
        }, 5)
      }
      slideUp()
    },
    open() {
      this.isOpen = true
      this.accordionHeight = 'auto'
    },
    close() {
      this.isOpen = false
      this.accordionHeight = 0
    },
  },
}
</script>
